import { Suspense } from 'react';

import { useFrustumMessageHandler } from 'app/modules/wallforming/components/frustum-viewer/hooks/useFrustumMessageHandler';
import { Articles } from 'app/modules/wallforming/components/scenes/objects/articles/Articles';
import { Building } from 'app/modules/wallforming/components/scenes/objects/building/Building';
import { FrustumCameraHelper } from 'app/modules/wallforming/components/scenes/objects/helpers/FrustumCameraHelper';

/**
 * FrustumViewerScene — Renders the 3D scene for the frustum viewer overlay.
 *
 * Includes:
 *   - Articles: Batched mesh mirroring the navigator scene
 *   - Building: View-only geometry and edge overlay
 *   - Frustum: CameraHelper synced to the main camera
 *
 * Data is kept in sync via SignalR updates and useFrustumMessageHandler.
 */
export const FrustumViewerScene = () => {
    useFrustumMessageHandler();

    return (
        <Suspense>
            <Building />
            <Articles isMainCanvas={false} />
            <FrustumCameraHelper />

            <ambientLight intensity={1.2} />
            <directionalLight intensity={0.6} position={[30, 80, 30]} />
            <axesHelper args={[5]} />
        </Suspense>
    );
};
